const AssessmentMethodOrder: string[] = [

    "SEL:All:2019-03-28:upload_pic",
    "SEL:All:2019-03-28:rs",
    "SEL:All:2019-03-28:m_z",
    "LOD:All:2019-03-28:cal_res",
    "LOD:All:2019-03-28:cal_y",
    "LOD:All:2019-03-28:cal_blanks",
    "LOD:All:2019-03-28:sd_6spike",
    "LOD:All:2019-03-28:cca_ccb_hetero",
    "LOD:All:2019-03-28:cca_ccb_homo",
    "LOD:All:2019-03-28:upload_vis",
    "LOD:All:2019-03-28:upload_s_n",
    "LIN:All:2019-03-28:1_6_1",
    "LIN:All:2019-03-28:1_5_1",
    "LIN:All:2019-03-28:1_5_3",
    "LIN:All:2019-03-28:3_5_1",
    "LIN:All:2019-03-28:2_6_1",
    "LIN:All:2019-03-28:3_6_2",
    "PREC:All:2019-03-28:1_1_6",
    "PREC:All:2019-03-28:1_3_3",
    "PREC:All:2019-03-28:1_4_5",
    "PREC:All:2019-03-28:2_1_6",
    "PREC:All:2019-03-28:2_3_3",
    "PREC:All:2019-03-28:3_4_1",
    "PREC:All:2019-03-28:reprod",
    "ACC:All:2019-03-28:1_3_3",
    "ACC:All:2019-03-28:1_4_5",
    "ACC:All:2019-03-28:3_4_1",
    "ACC:All:2019-03-28:1_1_10",
    "ACC:All:2019-03-28:ref_samp",
    "ACC:All:2019-03-28:ref_method"
];

export default AssessmentMethodOrder;